import farmImg from "../assets/product/farming.webp";
import processImg from "../assets/product/processing.webp";
import exportImg from "../assets/product/img11.webp";
import deliveryImg from "../assets/product/delivery.webp";

export default function WhyUs() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-white to-[#f6f7f5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        {/* Section Header */}
        <div className="max-w-3xl mb-14 text-center md:text-left">
          <p className="uppercase tracking-widest text-xs text-gray-500 mb-3">
            Our Promise
          </p>
          <h2 className="text-3xl md:text-4xl font-serif mb-5">
            Built on Quality, Trust & Consistency
          </h2>
          <p className="text-gray-700 leading-relaxed text-sm md:text-base">
            Kaaliglobal exports spices to countries across the Middle East,
            Asia, and Africa, including:
            <br />
            🇦🇪 UAE | 🇴🇲 Oman | 🇸🇦 Saudi Arabia | 🇶🇦 Qatar | 🇮🇳 India
            <br /><br />
            We follow strict packing standards, customized labeling, and
            provide HS codes, FSSAI certification, and export documentation
            as needed.
          </p>
        </div>

        {/* Value Flow */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-center">

          {/* Step Card */}
          {[
            {
              step: "01",
              title: "Farm-Level Sourcing",
              text: "Direct partnerships with trusted growers ensure consistent quality from the origin.",
              img: farmImg,
            },
            {
              step: "02",
              title: "Careful Processing",
              text: "Graded, cleaned, and packed to preserve aroma, freshness, and natural character.",
              img: processImg,
            },
            {
              step: "03",
              title: "Export-Ready Supply",
              text: "Products prepared for both domestic and international distribution standards.",
              img: exportImg,
            },
            {
              step: "04",
              title: "Reliable Delivery",
              text: "Consistent supply timelines and flexible packaging options for every order size.",
              img: deliveryImg,
            },
          ].map((item) => (
            <div
              key={item.step}
              className="bg-white rounded-2xl p-5 shadow-sm hover:shadow-md transition"
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-36 sm:h-40 object-cover rounded-xl mb-4"
              />
              <p className="text-xs uppercase tracking-widest text-gray-500 mb-1">
                Step {item.step}
              </p>
              <h4 className="font-serif text-lg mb-2">
                {item.title}
              </h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}
